<template>
  <div
    class=" flex items-center rounded-full p-1 px-2 my-2 text-xs border-vectric border "
    v-if="replyingTo"
  >
    <div class="mr-2 cursor-pointer" @click="cancelReply">
      <svg
        class="w-6 h-6 text-vectric hover:text-darkBlue"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>
    <span class="font-semibold">Replying to</span> :
    <span v-html="summary" class="ml-1"></span>
  </div>
</template>

<script>
import { truncate } from "../../utils/truncate";

export default {
  name: "ChatReplyNotice",
  props: {
    replyingTo: {}
  },
  methods: {
    cancelReply() {
      this.$emit("cancel-reply");
    }
  },
  computed: {
    summary() {
      if (this.replyingTo) {
        return truncate(this.replyingTo.body, 40);
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
